module.exports = __webpack_public_path__ + "img/28.758f740a.jpg";